import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService, DialogService } from '@box-core/services';
import { PhoneVerificationDialogComponent } from '@box-shared/components';
import { VerifyOTPResponse } from '@box-types';
import { Router } from '@angular/router';
import { isMobilePhone } from '@box-shared/validators';
import { GlobalStateService } from '@box-core/services/global-state.service';

@Injectable()
export class AccountContactService {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private dialogService: DialogService,
    private globalStateService: GlobalStateService
  ) {}

  public getVerifiedMSISDN(): string {
    const user = this.globalStateService.getUser();
    return user.verifiedMSISDN;
  }

  public getMobilePhoneNumbers(): string[] {
    const user = this.globalStateService.getUser();
    if (!user.assetsInfo?.length) return [];
    return user.assetsInfo.map((asset) => asset.msisdn).filter((msisdn) => isMobilePhone(msisdn));
  }

  public openPhoneVerificationDialog(mobilePhone: string): MatDialogRef<PhoneVerificationDialogComponent> {
    const dialogConfig: MatDialogConfig = {
      data: { autoGenerate: true, mobilePhone, verificationReason: 'mobile_phone_update' },
      ariaLabel: 'mobile_confirmation'
    };
    return this.dialogService.openDialog(PhoneVerificationDialogComponent, dialogConfig);
  }

  public updateUserDetails(verifyResponse: VerifyOTPResponse): void {
    const user = this.globalStateService.getUser();
    this.globalStateService.setUser({ ...user, ...verifyResponse });
  }

  public onProfileDeletion(): void {
    this.authenticationService.signOut();
    void this.router.navigate(['/']);
  }
}
